<template>
    <b-modal scrollable b-modal title="Riunione" ref="mdlRsaPazienteRiunioneEquipe" id="mdlRsaPazienteRiunioneEquipe" size="lg" @show="onShowModal" @ok="onOkMdlRiunione" ok-only centered no-close-on-backdrop no-close-on-esc hide-header-close style="height: 100%">
        <b-row v-show="!isStepNuovaPersonaRiferimetno">
            <b-col cols="12" xs="12" sm="12" md="6" lg="6" xl="6" class="sa-switch-select-element">
                <label class="sa-label-data">Data e Ora</label>
                <span>{{ formatDateTime(jsonData.dataOra) }}</span>
            </b-col>
            <b-col cols="12" xs="12" sm="12" md="6" lg="6" xl="6" class="sa-switch-select-element">
                <label class="sa-label-data">Compilatore</label>
                <span>{{ jsonData.createUser }}</span>
            </b-col>
            <b-col cols="12" xs="12" sm="12" md="12" lg="12" xl="12">
                <div style="flex: 1; height: 100%; background-color: transparent; overflow: hidden; display: flex; flex-direction: column">
                    <label class="sa-label-data">Verbale:</label>
                    <span v-html="jsonData.verbale"></span>
                </div>
            </b-col>
            <b-col cols="12" xs="12" sm="12" md="12" lg="12" xl="12" style="margin-top: 10px">
                <b-card class="sa-card sa-card-border" header="Membri equipe" header-tag="header" footer-tag="footer" title="">
                    <b-table sticky-header ref="table" stacked="lg" striped hover :items="jsonData.listaDettaglio" :fields="fieldsEquipe" :current-page="1" :per-page="50" :key="listKey" sort-icon-left head-variant="light" class="sa-b-table">
                        <template #cell(profilo)="item">
                            <span> {{ item.item.tipo }} </span>
                        </template>
                        <template #cell(nominativo)="item">
                            <span> {{ item.item.nome + " " + item.item.cognome }} </span>
                        </template>
                    </b-table>
                </b-card>
            </b-col>
        </b-row>
    </b-modal>
</template>
<script>
import UtilityMixin from "../../../utility/UtilityMixin";
/* import RsaEquipeComponent from "../../rsagestioneospiti/components/RsaEquipeComponent.vue"; */

export default {
    props: {},
    mixins: [UtilityMixin],
    components: {},
    data() {
        return {
            listKey: 0,
            pathResource: "/rsapazienteriunioneequipe",
            pathResourceUsers: "/users",
            pathResourceGruppo: "/gruppi",
            pathResourceEquipe: "/rsaequipe",
            pathResourcePersonaRiferimento: "/rsapersoneriferimento",
            nominativo: "",
            id: null,
            isModalRiunione: true,
            isStepNuovaPersonaRiferimetno: false,
            jsonData: {
                idAccettazione: "",
                dataOra: new Date().getTime(),
                listaDettaglio: [{ nome: "", tipo: "", cognome: "" }],
            },
            filtro: {},

            equipeOptions: [{ text: "-Seleziona membro equipe-", value: "" }],
            equipeTipoOptions: [],
            fieldsEquipe: [
                { label: "Profilo", key: "profilo", thStyle: "width: 7rem" },
                { label: "Nominativo", key: "nominativo", thStyle: "width: 7rem" },
            ],
            customToolbar: [
                ["bold", "italic", "underline", "strike"], // toggled buttons
                [{ align: "" }, { align: "center" }, { align: "right" }, { align: "justify" }],
                [{ list: "ordered" }, { list: "bullet" }, { list: "check" }],
                [{ indent: "-1" }, { indent: "+1" }], // outdent/indent
                [{ color: [] }, { background: [] }], // dropdown with defaults from theme
            ],
        };
    },
    mounted() {
        let me = this;
        me.idAccettazione = this.$route.query.idAccettazione;
    },
    watch: {},
    methods: {
        init(id) {
            let me = this;
            me.id = id;
            me.$refs.mdlRsaPazienteRiunioneEquipe.show();
        },
        onShowModal() {
            let me = this;
            if (me.id) {
                me.loadData();
            }
        },
        loadData() {
            let me = this;
            me.loadDataResources(me.pathResource + "/" + me.id, {}, me.resultResponse, me.resultError);
        },
        resultResponse(response) {
            let me = this;
            me.jsonData = response.data.data;
        },
        resultError(error) {
            let me = this;
            let messaggio = error.response.data.messaggio ? error.response.data.messaggio : "Elemento non trovato";
            me.$bvToast.toast(messaggio, {
                title: "Indicare il Caregiver",
                variant: "warning",
                solid: true,
            });
        },
        onOkMdlRiunione() {
            let me = this;
            me.$refs.mdlRsaPazienteRiunioneEquipe.hide();
        },
    },
};
</script>
